export const cardOrderItemStyle = `
  .card-order-item__container {
    position: relative;
    min-width: inherit;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: #FFFFFF;
    border-radius: 1rem;
    padding: 0 1em 1em;
    border: 1px solid #DDDDE9;
    box-shadow: 0px 6px 24px rgba(207, 195, 172, 0.2);
    transition: all 0.5s ease-in-out;
    gap: 1em;
  }
  .card-order-item__container:hover {
    box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
  }
  .card-order-item__container .card-order-item__bookmark {
    width: auto;
    height: auto;
    position: absolute;
    top: -0.4rem;
    left: 4rem;
  }
  .card-order-item__bookmark .card-order-item__circle_icon {
    display: none;
  }
  .card-order-item__content-item-order {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .card-order-item__content-order-checked {
    position: relative;
    width: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .card-order-item__check-container {
    display: block;
    position: relative;
    cursor: pointer;
  }
  .card-order-item__check-container input {
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .card-order-item__check-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.2rem;
    width: 1.2rem;
    background-color: #FFFFFF;
    border: solid 1.5px #002eff;
    border-radius: 0.3rem;
  }
  .card-order-item__check-container:hover input ~ .card-order-item__check-checkmark {
    background-color: #002eff;
  }
  .card-order-item__check-container input:checked ~ .card-order-item__check-checkmark {
    background-color: #002eff;
  }
  .card-order-item__check-checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .card-order-item__check-container input:checked ~ .card-order-item__check-checkmark:after {
    display: block;
  }
  .card-order-item__check-container .card-order-item__check-checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
  .card-order-item__content-order-info {
    width: 90%;
    height: 100%;
  }
  .card-order-item__header-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1em;
    padding-bottom: 0.3em;
    border-bottom: 1px solid #DDDDDD;
  }
  .card-order-item__header-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0 1em;
  }
  .card-order-item__header-icon, .card-order-item__header-arrow {
    width: 1.5rem;
    height: 1.5rem;
    color: #002eff;
  }
  .card-order-item__header-title {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 0.9rem;
    color: #23203F;
    text-transform: uppercase;
  }
  .card-order-item__body-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0.2em 1em;
  }
  .card-order-item__body-card-item-title, .card-order-item__body-card-item-value, .card-order-item__body-card-item-value--prepicking {
    font-family: 'Montserrat';
    font-size: 0.65rem;
    color: #716F87;
    overflow: hidden;
    white-space: normal;
  }
  .card-order-item__body-card-item-value, .card-order-item__body-card-item-value--prepicking,
  .card-order-item__body-card-item-wrapper .card-order-item__body-card-item-value{
    font-weight: 600;
    padding-left: 1em;
  }
  .card-order-item__lv__header-card .card-order-item__header-title {
    display: none;
    color: red;
  }
  .border-green {
    border: 1.5px solid #008f39;
  }
  .border-red {
    border: 1.5px solid #ff2c2c;
  }
  .border-gray {
    border: 1px solid #DDDDE9;
  }
  
  .card-order-item__body-card-item-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .card-order-item__body-card-item-wrapper p{
    padding-left: 0;
  }
  .card-order-item__body-card {
  }

  .order-list__cont-list.order-list__gv__cont-list .card-order-item__body-card-item-wrapper{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 1280px) {
    .card-order-item__body-card-item-wrapper {
      display: block;
    }
    .card-order-item__container {
      flex-wrap: wrap;
      gap: 0;
    }
    .card-order-item__lv__content-order-checked {
      position: relative;
      width: auto;
      padding: 0 0.8rem;
    }
    .card-order-item__header-title {
      font-size: 0.8rem;
      width: 165px;
    }
    .card-order-item__lv__container {
      width: inherit;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #FFFFFF;
      padding: 0.5rem 0;
      border: 1px solid #DDDDE9;
      border-radius: 1rem;
      box-shadow: 0px 6px 24px rgba(207, 195, 172, 0.2);
      transition: all 1s ease-in-out;
    }
    .card-order-item__lv__container .card-order-item__bookmark {
      width: auto;
      height: auto;
      position: absolute;
      top: 30%;
      left: 6rem;
    }
    .card-order-item__lv__container .card-order-item__bookmark .card-order-item__bookmark_icon {
      display: none;
    }
    .card-order-item__lv__container .card-order-item__bookmark .card-order-item__circle_icon {
      display: block;
      top: 2rem;
    }
    .card-order-item__lv__content-order-info {
      width: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .card-order-item__lv__content-item-order {
      width: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .card-order-item__lv__header-card {
      width: 20%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 0 1em;
      border: none;
    }
    .card-order-item__lv__header-card .card-order-item__header-arrow {
      display: none;
    }
    .card-order-item__lv__body-card {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    .card-order-item__lv__body-card-item--titles {
      display: none;
    }
    .card-order-item__lv__body-card-item--values {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      text-align: left;
    }
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper {
      width: 150px;
      text-overflow: hidden;
      white-space: wrap;
    }

    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper .card-order-item__body-card-item-title {
      display: none;
    }

    .order-list__lv__header-titles-container .order-list__lv__item-title:nth-child(2) {
      width: 100px;
    }    
    .order-list__lv__header-titles-container .order-list__lv__item-title:nth-child(3) {
      width: 100px;
    }
    .order-list__lv__header-titles-container .order-list__lv__item-title:nth-child(5) {
      width: 100px;
    }    
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper:nth-child(1) {
      width: 130px;
      padding-left: 40px;
    }    
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper:nth-child(2) {
      width: 120px;
    }
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper:nth-child(4) {
      width: 100px;
    }
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper:nth-child(9) {
      padding-left: 20px;
    }
    .card-order-item__lv__content-order-info .card-order-item__body-card-item-wrapper:nth-child(10) {
      
      padding-left: 20px;
    }

    .card-order-item__container--prepicking {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      place-content: center;
      background: #FFFFFF;
      border-radius: 1rem;
      padding: 0.5rem 1rem;
      box-shadow: 0px 6px 24px rgba(207, 195, 172, 0.2);
      border: 1px solid #DDDDE9;
      transition: all 0.5s ease-in-out;
      gap: 1em;
    }
    .card-order-item__body-card-item-value--prepicking {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
    .card-order-item__container--prepicking--first-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
    }
  }
`